<div class="fb-wrap">
  <div class="content-overlay">
    <div class="file-browse__header">
      <span class="file-browse__header__info">
        Vybraných souborů:
        <strong>{{ chosen.length }}</strong>
      </span>
      <a (click)="submitFiles()" class="cta cta--small cta--green">
        <i class="ico-success"></i> Potvrdit
        <span class="cta--light">výběr</span>
      </a>
      <a (click)="close()" class="cta cta--small cta--red">
        <i class="ico-remove"></i> Zavřít</a>
      <div class="file-browse__header__filter">
        <swb-filter-list (modelChange)="filter($event)" [bgColor]="'white'"></swb-filter-list>
      </div>
    </div>
    <div class="file-browse__wrap">
      <pagination-controls *ngIf="pagination.pageSize > 0 && isInitialized" id="browse-files" (pageChange)="pageChanged($event)"
        maxSize="9" directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination"
        screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce">
      </pagination-controls>
      <div id="file-list" class="paginated-content media__list" *ngIf="isInitialized">
        <div *ngFor="let file of files | paginate: { id: 'browse-files', itemsPerPage: pagination.pageSize, currentPage:
  p, totalItems: pagination.total }" class="media__list__item">
          <a (click)="chooseFile(file);" [ngClass]="{'media__list__item__box--chosen': chosen.includes(file)}" class="media__list__item__box media__list__item__box--choosable"
            [ngStyle]="getBoxStyle(file.is_image, file.is_resizable, file.file_fullname)">
            <div class="media__list__item__filetype media__list__item__filetype--{{file.extension}}">{{file.extension}}</div>
            <div class="media__list__item__filename" *ngIf="!file.is_image">
              <span class="media__list__item__filename__inside">{{ file.file_name }}</span>
            </div>
            <div class="media__list__item__actions">
              <div class="media__list__item__actions__title">{{ file.file_name }}</div>
              <br>
              <span class="media__list__item__actions__link media__list__item__actions__link--view" title="Vybrat soubor.">
                <i class="ico-success"></i>
              </span>
            </div>
          </a>
        </div>
      </div>
      <pagination-controls *ngIf="pagination.pageSize > 0 && isInitialized" id="browse-files" (pageChange)="pageChanged($event)"
        maxSize="9" directionLinks="true" autoHide="true" previousLabel="" nextLabel="" screenReaderPaginationLabel="Pagination"
        screenReaderPageLabel="Stránka" screenReaderCurrentLabel="Jste na stránce">
      </pagination-controls>


      <div class="loading loading--dark" *ngIf="!isInitialized"></div>

      <swb-no-data *ngIf="files && files.length === 0"></swb-no-data>
    </div>
  </div>
</div>